// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1_Hce","cls2":"PaperSelector-cls2_z7s PaperSelector-cls1_Hce"};